import {
    ColoursObj,
    Gutters,
    MenuButton,
    StyledPullToRefresh,
    Typography,
} from '@eventr/common-storybook'
import { Radio, Stack } from '@mui/material'
import { useEffect } from 'react'
import i18n from '../../../i18n/i18next'
import { bs } from '../../../state/bound.store'
import {
    availableLang,
    useLanguageContext,
} from '../../../state/languageState/languageContext'
import { NavigationView } from '../../layout/NavigationView'

export default function LanguagePage() {
    const { selectedLanguage, setLanguage } = useLanguageContext()
    const langMap = new Map(Object.entries(availableLang))

    useEffect(() => {
        if (selectedLanguage !== i18n.language) {
            setLanguage(i18n.language as availableLang)
        }
    }, [selectedLanguage])

    return (
        <NavigationView
            navigationBarTitle={i18n.t('account.language')}
            backButtonAction={() => {
                window.pushPath('/account/settings')
            }}
            usePageTransition
        >
            <StyledPullToRefresh
                onRefresh={async () => {
                    // Nothing
                }}
                promiseFunction={async () => {
                    await bs().getProfile()
                }}
                maxPullDownDistance={70}
            >
                <Gutters>
                    <Stack gap={'16px'}>
                        {Array.from(langMap).map(([key, value]) => (
                            <div key={key}>
                                <MenuButton
                                    onClick={() => {
                                        i18n.changeLanguage(value, (err) => {
                                            if (!err) {
                                                setLanguage(value)
                                            } else {
                                                console.error(
                                                    'Error changing language:',
                                                    err
                                                )
                                            }
                                        })
                                    }}
                                    style={{
                                        background:
                                            ColoursObj.backgrounds.secondary,
                                    }}
                                >
                                    <Stack
                                        flexDirection="row"
                                        gap="16px"
                                        alignItems="center"
                                    >
                                        <Radio
                                            style={{ padding: '0px' }}
                                            sx={{
                                                color: ColoursObj.font.primary,
                                            }}
                                            checked={selectedLanguage === value}
                                        />
                                        <Stack
                                            display={'grid'}
                                            justifyItems={'start'}
                                        >
                                            <Typography
                                                variant="bodyRegular"
                                                color={ColoursObj.font.primary}
                                                lineHeight={'16px'}
                                            >
                                                {i18n.t(
                                                    `language.${value.toLowerCase()}`
                                                )}
                                            </Typography>
                                            <Stack height={'4px'} />
                                            <Typography
                                                variant="bodySubtext"
                                                color={
                                                    ColoursObj.font.secondary
                                                }
                                                lineHeight={'16px'}
                                            >
                                                {selectedLanguage !== value &&
                                                    i18n.getFixedT(value)(
                                                        `language.${value.toLowerCase()}`
                                                    )}
                                            </Typography>
                                        </Stack>
                                    </Stack>
                                </MenuButton>
                            </div>
                        ))}
                        <Stack height={'32px'} />
                    </Stack>
                </Gutters>
            </StyledPullToRefresh>
        </NavigationView>
    )
}
